import { Box } from "@chakra-ui/react";
import { PageCanvas } from "../../../layouts/PageCanvas";
import { PageContainer } from "../../../layouts/PageContainer";
import { PageHeader } from "../../../layouts/PageHeader";
import Registries from "./Registries";

const PageRegistries = () => {
  return (
    <PageContainer>
      <PageHeader title="Registries" isIncludeProfile={true}></PageHeader>
      <PageCanvas overflow="auto">
        <Box px={"4"} py={8}>
          <Registries></Registries>
        </Box>
      </PageCanvas>
    </PageContainer>
  );
};

export default PageRegistries;
